import { _ as _slicedToArray } from '../../../../slicedToArray-26803f33.js';
import { _ as _toConsumableArray } from '../../../../toConsumableArray-2a2700d9.js';
import { _ as _defineProperty } from '../../../../defineProperty-18999f8e.js';
import { i as isEqual_1 } from '../../../../isEqual-347ac7db.js';
import { t as tinycolor } from '../../../../tinycolor-c9a47691.js';
import { SVG_RELATIVE_MARKERS, SVG_ABSOLUTE_MARKERS, RANGE_MIN_VALUE, RANGE_MAX_VALUE, SVG_COMMAND_REG_EXP, HUNDRED_PERCENT, TRANSPARENT_RGBA, DEFAULT_BLACK, SPECIAL_SHAPES, DEFAULT_COLOR, MARKER_REG_EX, FLOAT_INT_REGEXP, CONTRAST_MAX_VALUE, CONTRAST_MIN_VALUE } from '../../../../configs/index.js';
import { replacer } from '../../../../utils/vector/index.js';
import roundPathCorners from '../svg-utils/index.js';
import '../../../../unsupportedIterableToArray-577176bf.js';
import '../../../../isObjectLike-66611f04.js';
import '../../../../typeof-92b42de1.js';
import '../../../../_commonjsHelpers-1789f0cf.js';
import '../../../../index-6bb2031f.js';
import '../../../../v4-c5e36445.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var z = SVG_RELATIVE_MARKERS.z,
    h = SVG_RELATIVE_MARKERS.h,
    v = SVG_RELATIVE_MARKERS.v,
    l = SVG_RELATIVE_MARKERS.l,
    c = SVG_RELATIVE_MARKERS.c,
    a = SVG_RELATIVE_MARKERS.a,
    s = SVG_RELATIVE_MARKERS.s,
    t = SVG_RELATIVE_MARKERS.t,
    q = SVG_RELATIVE_MARKERS.q;
var L = SVG_ABSOLUTE_MARKERS.L,
    V = SVG_ABSOLUTE_MARKERS.V,
    H = SVG_ABSOLUTE_MARKERS.H,
    Z = SVG_ABSOLUTE_MARKERS.Z;
/* _____________________________________ Specefic Adjustment Ranges _____________________________________ */

var convertRangeToFiltersRange = function convertRangeToFiltersRange(value, newMin, newMax) {
  return (value - RANGE_MIN_VALUE) / (RANGE_MAX_VALUE - RANGE_MIN_VALUE) * (newMax - newMin) + newMin;
};
function getAdjustParams(settings) {
  return settings.reduce(function (acc, item) {
    acc[item.name] = item.value;
    return acc;
  }, {});
}
/* _____________________________________ SVG MANIPULATIONS _____________________________________ */

var convertSVGToPathCommands = function convertSVGToPathCommands(pathString) {
  return pathString.match(SVG_COMMAND_REG_EXP).map(function (el) {
    var _el$match;

    var marks = el.match(MARKER_REG_EX);
    var marker = marks[0];
    var isNotZ = ![z, Z].includes(marker);
    var values = isNotZ && ((_el$match = el.match(FLOAT_INT_REGEXP)) === null || _el$match === void 0 ? void 0 : _el$match.map(parseFloat)) || [];
    return {
      marker: marker,
      values: values
    };
  });
};

var scaleValuesToProvidedSizes = function scaleValuesToProvidedSizes(values, options) {
  var _options$newWidth = options.newWidth,
      newWidth = _options$newWidth === void 0 ? 1 : _options$newWidth,
      _options$newHeight = options.newHeight,
      newHeight = _options$newHeight === void 0 ? 1 : _options$newHeight,
      _options$moveX = options.moveX,
      moveX = _options$moveX === void 0 ? 0 : _options$moveX,
      _options$moveY = options.moveY,
      moveY = _options$moveY === void 0 ? 0 : _options$moveY;
  return values.map(function (value, idx) {
    return value * (idx % 2 ? newHeight : newWidth) + (idx % 2 ? moveY : moveX);
  });
};

var pathChanger = function pathChanger(pathObjects, options) {
  var _options$moveX2 = options.moveX,
      moveX = _options$moveX2 === void 0 ? 0 : _options$moveX2,
      _options$moveY2 = options.moveY,
      moveY = _options$moveY2 === void 0 ? 0 : _options$moveY2,
      _options$newWidth2 = options.newWidth,
      newWidth = _options$newWidth2 === void 0 ? 1 : _options$newWidth2,
      _options$newHeight2 = options.newHeight,
      newHeight = _options$newHeight2 === void 0 ? 1 : _options$newHeight2;
  return pathObjects.reduce(function (acc, pathObject, index) {
    var _acc$;

    var nextCommand = _objectSpread(_objectSpread({}, pathObject), {}, {
      values: _toConsumableArray(pathObject.values)
    });

    var prevPathObject = acc[index - 1];
    var prevLength = prevPathObject === null || prevPathObject === void 0 ? void 0 : prevPathObject.values.length;

    var _ref = (prevLength > 2 ? [prevPathObject === null || prevPathObject === void 0 ? void 0 : prevPathObject.values[prevLength - 2], prevPathObject === null || prevPathObject === void 0 ? void 0 : prevPathObject.values[prevLength - 1]] : prevPathObject === null || prevPathObject === void 0 ? void 0 : prevPathObject.values) || [0, 0],
        _ref2 = _slicedToArray(_ref, 2),
        prevX = _ref2[0],
        prevY = _ref2[1];

    if (pathObject.marker === L && isEqual_1(scaleValuesToProvidedSizes(pathObject === null || pathObject === void 0 ? void 0 : pathObject.values, options), (_acc$ = acc[0]) === null || _acc$ === void 0 ? void 0 : _acc$.values)) {
      // We add virtual closing line while curving, so this won't be needed
      return acc;
    }

    if (SVG_RELATIVE_MARKERS[pathObject.marker]) {
      switch (pathObject.marker) {
        case h:
          nextCommand.marker = L;
          nextCommand.values = [pathObject.values[0] * newWidth + prevX, prevY];
          acc.push(nextCommand);
          return acc;

        case v:
          nextCommand.marker = L;
          nextCommand.values = [prevX, pathObject.values[0] * newHeight + prevY];
          acc.push(nextCommand);
          return acc;

        case l:
          nextCommand.marker = pathObject.marker.toUpperCase();
          nextCommand.values = scaleValuesToProvidedSizes(pathObject.values, options).map(function (el, indx) {
            return el + (indx % 2 ? prevY : prevX);
          });
          acc.push(nextCommand);
          return acc;

        case c:
        case a:
        case z:
        case s:
        case t:
        case q:
          nextCommand.marker = pathObject.marker.toUpperCase();
          nextCommand.values = scaleValuesToProvidedSizes(pathObject.values, options).map(function (el, indx) {
            var fit = el < 0 ? -1 : 1;
            return el + fit * (indx % 2 ? prevX : prevY);
          });
          acc.push(nextCommand);
          return acc;
      }
    }

    if (pathObject.marker === H) {
      nextCommand.marker = L;
      nextCommand.values = [pathObject.values[0] * newWidth + moveX, prevY];
      acc.push(nextCommand);
      return acc;
    }

    if (pathObject.marker === V) {
      nextCommand.marker = L;
      nextCommand.values = [prevX, pathObject.values[0] * newHeight + moveY];
      acc.push(nextCommand);
      return acc;
    }

    nextCommand.values = scaleValuesToProvidedSizes(nextCommand.values, options);
    acc.push(nextCommand);
    return acc;
  }, []);
};

function forEachSvgCommands(path, callback) {
  return path.replace(SVG_COMMAND_REG_EXP, callback);
}

var checkNotRoundable = function checkNotRoundable(pathD) {
  return pathD.includes('c') || pathD.includes('C') || pathD.includes('A') || pathD.includes('a');
};

function handlePointerPath(paths, options) {
  var width = options.width,
      height = options.height,
      settings = options.settings,
      defaultRadius = options.cornerRadius,
      colorRGB1 = options.colorRGB1,
      outlineColor = options.outlineColor,
      outlineSize = options.outlineSize,
      colorTransparent = options.colorTransparent,
      outlineTransparent = options.outlineTransparent,
      opacityOutline = options.opacityOutline,
      opacity = options.opacity,
      shadowBlur = options.shadowBlur,
      shadowColor = options.shadowColor,
      shadowOpacity = options.shadowOpacity,
      shadowOffsetX = options.shadowOffsetX,
      shadowOffsetY = options.shadowOffsetY,
      shadowTransparent = options.shadowTransparent;

  var _ref3 = getAdjustParams(settings),
      _ref3$contrast = _ref3.contrast,
      contrast = _ref3$contrast === void 0 ? 0 : _ref3$contrast,
      _ref3$thickness = _ref3.thickness,
      thickness = _ref3$thickness === void 0 ? 0 : _ref3$thickness,
      _ref3$saturation = _ref3.saturation,
      saturation = _ref3$saturation === void 0 ? 0 : _ref3$saturation,
      _ref3$brightness = _ref3.brightness,
      brightness = _ref3$brightness === void 0 ? 0 : _ref3$brightness,
      _ref3$cornerRadius = _ref3.cornerRadius,
      cornerRadius = _ref3$cornerRadius === void 0 ? defaultRadius : _ref3$cornerRadius,
      adjustOpacity = _ref3.opacity;

  var newWidth = width - width * thickness / (2 * HUNDRED_PERCENT);
  var newHeight = height - height * thickness / (2 * HUNDRED_PERCENT);
  var moveX = (width - newWidth) / 2;
  var moveY = (height - newHeight) / 2;
  var isMultiPath = paths.length > 1;
  return paths.map(function (pathData) {
    var _ref4, _ref5;

    var notRoundable = checkNotRoundable(pathData.path);
    var convertedOpacity = !!opacity && (opacity > 1 ? opacity / HUNDRED_PERCENT : opacity);
    var calculateOP = (_ref4 = (convertedOpacity || pathData.opacity || 1) * HUNDRED_PERCENT) !== null && _ref4 !== void 0 ? _ref4 : HUNDRED_PERCENT;
    var calcedOpacity = adjustOpacity !== null && adjustOpacity !== void 0 ? adjustOpacity : calculateOP;
    var fillStyle = colorTransparent ? TRANSPARENT_RGBA : tinycolor(colorRGB1 || pathData.fill || DEFAULT_BLACK).setAlpha(calcedOpacity / HUNDRED_PERCENT).toRgbString();
    var adjustmentFilters = {
      saturation: saturation,
      contrast: convertRangeToFiltersRange(contrast, CONTRAST_MIN_VALUE, CONTRAST_MAX_VALUE) / HUNDRED_PERCENT,
      brightness: brightness
    };
    var isSpecialShape = Object.values(SPECIAL_SHAPES).find(function (el) {
      return el.path === pathData.path;
    });
    var newPathData = {
      fillStyle: fillStyle,
      opacityOutline: opacityOutline,
      outlineTransparent: outlineTransparent,
      shadowBlur: shadowBlur,
      shadowColor: shadowColor,
      shadowOpacity: shadowOpacity,
      shadowOffsetX: shadowOffsetX,
      shadowOffsetY: shadowOffsetY,
      shadowTransparent: shadowTransparent,
      adjustmentFilters: adjustmentFilters,
      calcedOpacity: colorTransparent ? 0 : calcedOpacity / HUNDRED_PERCENT,
      strokeWidth: outlineSize !== null && outlineSize !== void 0 ? outlineSize : pathData.strokeWidth,
      opacity: colorTransparent ? 0 : ((_ref5 = adjustOpacity !== null && adjustOpacity !== void 0 ? adjustOpacity : pathData.opacity) !== null && _ref5 !== void 0 ? _ref5 : 100) / HUNDRED_PERCENT,
      strokeColor: tinycolor((outlineColor !== null && outlineColor !== void 0 ? outlineColor : pathData.stroke) || DEFAULT_COLOR).toRgb()
    };

    if (isMultiPath || notRoundable || isSpecialShape) {
      var oldReplace = forEachSvgCommands(pathData.path, function (match) {
        return replacer(match, newWidth, newHeight, {
          moveX: isSpecialShape ? isSpecialShape.movePoints.moveX : (width - newWidth) / 2,
          moveY: isSpecialShape ? isSpecialShape.movePoints.moveY : (height - newHeight) / 2
        });
      });
      return _objectSpread(_objectSpread(_objectSpread({}, pathData), newPathData), {}, {
        path: new Path2D(oldReplace)
      });
    }

    var pathObjects = convertSVGToPathCommands(pathData.path);
    var convertedPathObject = pathChanger(pathObjects, {
      newWidth: newWidth,
      newHeight: newHeight,
      moveX: moveX,
      moveY: moveY
    });
    var pathObjectToString = convertedPathObject.reduce(function (acc, item) {
      return "".concat(acc, " ").concat(item.marker, " ").concat(item.values.join(' '));
    }, '');

    if (cornerRadius) {
      return _objectSpread(_objectSpread(_objectSpread({}, pathData), newPathData), {}, {
        path: new Path2D(roundPathCorners(pathObjectToString, cornerRadius / (2 * HUNDRED_PERCENT)))
      });
    }

    return _objectSpread(_objectSpread(_objectSpread({}, pathData), newPathData), {}, {
      path: new Path2D(pathObjectToString)
    });
  });
}

export { convertRangeToFiltersRange, forEachSvgCommands, getAdjustParams, handlePointerPath };
